import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { spotFinder } from "../app/endpoints";
import axiosBaseQuerySpotfinder from "./axiosBaseQuerySpotfinder";

export const RLRestApi = createApi({
  reducerPath: "RLRestApi",
  baseQuery: axiosBaseQuerySpotfinder({
    baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL,
  }),
  tagTypes: ["RLRest"],
  endpoints: (builder) => ({
    getAmenities: builder.mutation({
      query: (body) => {
        return {
          url: spotFinder.RLRestController.getAmenities,
          method: "GET",
          headers: {Authorization: `Bearer ${body.token}`},
          body: body.payload,
        };
      },
    }),

    getCostOfLocationType: builder.mutation({
      query: (body) => {
        return {
          url: spotFinder.RLRestController.getCostOfLocationType,
          method: "PUT",
          headers: body.token ? { Authorization: `Bearer ${body.token}` } : {},
          body: body.payload,
        };
      },
    }),
  }),
});

export const {useGetAmenitiesMutation, useGetCostOfLocationTypeMutation } =
  RLRestApi;
